import { render, staticRenderFns } from "./BaseCheckBox.vue?vue&type=template&id=5d8c4eec&scoped=true"
import script from "./BaseCheckBox.vue?vue&type=script&lang=js"
export * from "./BaseCheckBox.vue?vue&type=script&lang=js"
import style0 from "./BaseCheckBox.vue?vue&type=style&index=0&id=5d8c4eec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8c4eec",
  null
  
)

export default component.exports